import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropdownModule } from '../dropdown';
import { LangPickerComponent } from './components';

@NgModule({
    imports: [
        CommonModule,

        DropdownModule,
    ],
    declarations: [
        LangPickerComponent,
    ],
    exports: [
        LangPickerComponent,
    ],
})

export class LangPickerModule {}
